<template>
  <footer class="footer">
    <div class="before" />
    <div class="top">
      <div class="container">
        <AppLink to="/">
          <img :src="yavagroFull" class="logo" alt="logo" />
        </AppLink>

        <FooterMenu />
      </div>
    </div>

    <div class="middle">
      <div class="container">
        <div class="copyright">
          <img :src="logoRshb" class="icon" alt="" />
          <div v-sane-html="copyrightText" class="text" />
        </div>

        <div class="location">
          <p class="item">{{ location.address }}</p>
          <p class="item">
            E-mail:
            <a :href="`mailto:${location.email}`">
              {{ location.email }}
            </a>
          </p>
        </div>
      </div>
    </div>

    <div class="bottom">
      <FooterMenuBottom />
    </div>
  </footer>
</template>

<script setup lang="ts">
  import { FooterMenu, FooterMenuBottom } from '~/components/layouts/footer'
  import { AppLink } from '~/components/base-ui/link'
  import yavagroFull from '~/assets/images/logotypes/yavagro-full.svg'
  import logoRshb from '~/assets/images/logotypes/logo-rshb.svg'

  const copyrightText = `© 2000-${new Date().getFullYear()} АО «Россельхозбанк»<br> Генеральная лицензия Банка России № 3349 от 12 августа 2015`

  const location = {
    address: '119034, г. Москва, Гагаринский пер., д.3',
    email: 'office@rshb.ru',
  }
</script>

<style lang="scss" scoped>
  .footer {
    @extend %flex-column;

    width: 100%;
    z-index: 1;

    > .before {
      min-height: 180px;
      background-image: url('~/assets/images/footer/footer-white.svg');
      background-size: cover;
      background-position: center bottom;
      background-repeat: no-repeat;
    }

    > .top {
      background: $color-default-white;
      padding: 60px 0;

      @include vp-1439 {
        padding: 40px 0;
      }

      @include vp-767 {
        padding: 24px 0;
      }
    }

    > .top > .container {
      @include container;
      @extend %flex, %content-between;

      @include vp-1439 {
        justify-content: unset;
        flex-direction: column;
      }
    }

    > .middle {
      background: $color-kiwi-10;
      flex-grow: 1;
      padding: 40px 0;
      position: relative;

      @include vp-767 {
        background: $color-default-white;
        padding: 0 0 24px;
      }

      &::after {
        content: '';
        height: 1px;
        background: #f0f0f0;
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }

    > .middle > .container {
      @include container;
      @extend %flex-inline, %content-between;

      @include vp-767 {
        flex-direction: column;
        padding-right: 32px;
      }
    }

    > .middle > .container > .copyright {
      color: $color-potato-30;
      display: flex;
      gap: 40px;
      align-items: center;
    }

    > .middle > .container > .copyright > .icon {
      @include vp-767 {
        display: none;
      }
    }

    > .middle > .container > .copyright > .text {
      @extend %font-12;
    }

    > .middle > .container > .location {
      @extend %font-12;

      > .item {
        margin-top: 5px;
      }

      @include vp-767 {
        padding-top: 20px;
      }
    }

    > .bottom {
      @include container;

      padding: 48px 0;

      @include vp-767 {
        background: $color-default-white;
        padding: 24px 16px;
      }
    }
  }
</style>
